import { Modal, Box, Title, Text, Button, Flex, SimpleGrid } from "@mantine/core";
import { IconSparkles } from "@tabler/icons-react";

interface ProfileGenerateModalProps {
  opened: boolean;
  onClose: () => void;
  onGenerate: () => void;
}

export default function ProfileGenerateModal({ opened, onClose, onGenerate }: ProfileGenerateModalProps) {
  const features = ["Company Overview", "Manufacturing Capabilities", "Products & Services", "Contact Information"];

  const handleSkip = () => {
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size="lg"
      radius="lg"
      withCloseButton={false}
      padding={0}
      styles={{
        content: {
          borderRadius: 16,
        },
        body: {
          padding: 0,
        },
      }}
    >
      <Box p="xl">
        {/* Icon */}
        <Flex justify="center" mb="lg">
          <Box
            style={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "#EEF2FF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconSparkles size={28} color="#2563EB" />
          </Box>
        </Flex>

        {/* Title */}
        <Title order={2} ta="center" fz={20} mb="xs">
          AI-Powered Profile Generator
        </Title>

        {/* Description */}
        <Text ta="center" c="slate.6" fz="sm" mb="xl" px="md">
          Create professional company profiles automatically using GTsetu AI. Simply provide your company URL and upload a
          brochure to get started.
        </Text>

        {/* CTA Buttons */}
        <Flex direction="row" gap="sm" mb="xl" align="stretch" wrap="wrap">
          <Button
            flex={1}
            size="lg"
            leftSection={<IconSparkles size={18} />}
            onClick={onGenerate}
            styles={{
              root: {
                minHeight: 80,
              },
              label: {
                flexDirection: "column",
                gap: 2,
                alignItems: "center",
                justifyContent: "center",
              },
            }}
          >
            <Text fz="sm" fw={600} component="span" lh={1.2} c="inherit">
              Create Profile with AI
            </Text>
            <Text fz={10} fw={500} component="span" lh={1} opacity={0.92} tt="uppercase" c="inherit">
              (Recommended)
            </Text>
          </Button>

          <Button
            flex={1}
            size="lg"
            variant="outline"
            color="blue"
            onClick={handleSkip}
            styles={{
              root: {
                minHeight: 80,
              },
            }}
          >
            Skip & Create Manually
          </Button>
        </Flex>

        {/* Divider with "WHAT GTsetu AI WILL GENERATE" */}
        <Box
          style={{
            borderTop: "1px solid #E5E7EB",
            paddingTop: 20,
          }}
        >
          <Text fz="xs" ta="center" c="slate.6" mb="md" style={{ letterSpacing: "0.5px" }}>
            WHAT GTsetu AI WILL GENERATE
          </Text>

          {/* Features Grid */}
          <SimpleGrid cols={2} spacing="xs">
            {features.map((feature, index) => (
              <Flex key={index} align="center" gap={8}>
                <Box
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    backgroundColor: "#4F6EF7",
                    flexShrink: 0,
                  }}
                />
                <Text fz="sm" c="dark">
                  {feature}
                </Text>
              </Flex>
            ))}
          </SimpleGrid>
        </Box>
      </Box>
    </Modal>
  );
}
